import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrCreateTermTypePayload } from 'api/actions/hr-create-term-type/hr-create-term-type-payload';
import { HrCreateTermTypePathParameters } from 'api/actions/hr-create-term-type/hr-create-term-type-path-parameters';
import { HrCreateTermTypeResponse } from 'api/actions/hr-create-term-type/hr-create-term-type-response';

type HrCreateTermTypeQueryParameters = Record<string, any>;

/**
 * The path of the HrCreateTermType action.
 */
export const hrCreateTermTypeActionPath = new SweetPath<keyof HrCreateTermTypePathParameters>('/api/hr/term-types', {
  path: '{param}',
});

/**
 * Creates a contextualized HrCreateTermType actions.
 */
export default function createHrCreateTermTypeAction(axios: AxiosInstance) {
  return function hrCreateTermTypeAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: HrCreateTermTypeQueryParameters;
    payload: HrCreateTermTypePayload;
  }) {
    const path = hrCreateTermTypeActionPath.original;

    return axios.request<HrCreateTermTypeResponse, HrCreateTermTypeResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
